import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { useNavigate } from "react-router-dom";

const CARD_ICONS = ['🍕', '🍔', '🍟', '🌮', '🍣', '🍩', '🍪', '🥐'];

const CARD_IMAGES = [
  'https://admin.ubikalo.app/public/uploads/places/logos/112e92ffd2e0db2f08b1a6ea711c5b8421a7cea0-logo.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/3e36ed8bf16237aeeb4eefc199579d2ddb4cbfec-logo.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/c8fce6c62ffaa974cd49211e0c09c750a2aa5713-503574330_1116010590556511_1167682170416516104_n.jpg', // ejemplo papas
  'https://admin.ubikalo.app/public/uploads/places/logos/a0c7a99af52b8935720b0bb3977730fd41dcb622-logo.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/e47b8367513d24f53905014f8420af3d19f221f0-logo.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/aab03fad0f168adccd719a4dc716f65ca2cf359c-lefleur.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/24ff64e63c730dc4762b3a9c77252deec9d444dd-logo.webp',
  'https://admin.ubikalo.app/public/uploads/places/logos/0060e52451e89699f10cdeb47012269ec2897495-logo.webp',
];

const TIME_LIMIT = 25; // segundos

const shuffleArray = (arr) => {
  const array = [...arr];
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};


const MemoryGame = () => {
    const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [juegoIniciado, setJuegoIniciado] = useState(false);
  const [matched, setMatched] = useState([]);
  const [timeLeft, setTimeLeft] = useState(TIME_LIMIT);
  const [gameOver, setGameOver] = useState(false);
  const [winner, setWinner] = useState(false);

  useEffect(() => {
  if (juegoIniciado && timeLeft > 0 && !winner) {
    const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    return () => clearTimeout(timer);
  } else if (timeLeft === 0) {
    setGameOver(true);
  }
}, [timeLeft, winner, juegoIniciado]);

  useEffect(() => {
    const duplicated = [...CARD_IMAGES, ...CARD_IMAGES];
    const shuffled = shuffleArray(duplicated).map((icon, index) => ({
      id: index,
      icon,
      flipped: false,
    }));
    setCards(shuffled);
  }, []);

  useEffect(() => {
    if (timeLeft > 0 && !winner) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0) {
      setGameOver(true);
    }
  }, [timeLeft, winner]);

  useEffect(() => {
    if (matched.length === CARD_ICONS.length) {
      setWinner(true);
      setGameOver(true);
    }
  }, [matched]);

  const handleCardClick = (index) => {
    if (gameOver || flipped.length === 2 || flipped.includes(index) || matched.includes(cards[index].icon)) return;

    const newFlipped = [...flipped, index];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      const [first, second] = newFlipped;
      if (cards[first].icon === cards[second].icon) {
        setMatched((prev) => [...prev, cards[first].icon]);
        setFlipped([]);
      } else {
        setTimeout(() => setFlipped([]), 1000);
      }
    }
  };

  const resetGame = () => {
     window.location.reload();
  };

  return (
  <div style={styles.container}>
    <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/home")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Juego de memoria</h2>
      </div>

    {!juegoIniciado ? (
      <button style={styles.button} onClick={() => setJuegoIniciado(true)}>
        Iniciar Juego
      </button>
    ) : (
      <>
        <p style={{fontWeight:600, color:"red"}}>Tiempo restante: {timeLeft}s</p>

        <div style={styles.grid}>
          {cards.map((card, index) => {
            const isFlipped = flipped.includes(index) || matched.includes(card.icon);
            return (
              <div
                key={card.id}
                style={{
                  ...styles.card,
                  backgroundColor: isFlipped ? '#fff' : '#d7d7d7',
                }}
                onClick={() => handleCardClick(index)}
              >
                {isFlipped ? <img src={card.icon} alt="card" style={styles.img} /> : null}
              </div>
            );
          })}
        </div>

        {gameOver && (
          <div style={styles.modal}>
            <h2>{winner ? '🎉 ¡Ganaste un premio!' : 'Tiempo agotado'}</h2>
            <button onClick={resetGame} style={styles.button}>Reiniciar</button>
          </div>
        )}

        {winner && <Confetti />}
      </>
    )}
  </div>
);

};

const styles = {
  container: {
    textAlign: 'center',
    fontFamily: 'sans-serif',
    padding: 25,
    marginRight:10,
    marginLeft:10
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 80px)',
    gap: '5px',
    justifyContent: 'center',
    marginTop: 20,
  },
  img: {
    width: 80,
    borderRadius: 10,
    height: 80,
    objectFit: 'cover',
  },
  card: {
    width: 80,
    height: 80,
    backgroundColor: '#333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 32,
    borderRadius: 10,
    cursor: 'pointer',
    color: '#000',
  },
  icon: {
    fontSize: 36,
  },
  modal: {
    marginTop: 30,
  },
  button: {
    padding: '10px 20px',
    fontSize: 16,
    marginTop: 10,
    cursor: 'pointer',
    borderRadius: 5,
    background: "black",
    color: "white",
    border: "none",
  },
};

export default MemoryGame;